var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.613794 10.904C0.53479 10.9044 0.456473 10.8893 0.383334 10.8594C0.310194 10.8295 0.243671 10.7855 0.187579 10.7299C0.131313 10.6741 0.0866541 10.6077 0.0561774 10.5345C0.0257008 10.4614 0.0100098 10.3829 0.0100098 10.3037C0.0100098 10.2244 0.0257008 10.1459 0.0561774 10.0728C0.0866541 9.99964 0.131313 9.93324 0.187579 9.87744L4.5698 5.50122L0.187579 1.12501C0.0745392 1.01197 0.0110345 0.858653 0.0110345 0.698791C0.0110345 0.619636 0.026625 0.541255 0.0569165 0.468125C0.0872081 0.394995 0.131607 0.328547 0.187579 0.272576C0.24355 0.216604 0.309998 0.172205 0.383128 0.141914C0.456258 0.111622 0.534639 0.0960312 0.613794 0.0960312C0.773656 0.0960312 0.926971 0.159536 1.04001 0.272576L5.84244 5.07501C5.89871 5.13081 5.94337 5.19721 5.97384 5.27036C6.00432 5.34351 6.02001 5.42197 6.02001 5.50122C6.02001 5.58047 6.00432 5.65893 5.97384 5.73208C5.94337 5.80524 5.89871 5.87163 5.84244 5.92744L1.04001 10.7299C0.983918 10.7855 0.917394 10.8295 0.844255 10.8594C0.771115 10.8893 0.692798 10.9044 0.613794 10.904Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.ec8261d1cee59a9cea3ea12886ec5562.svg";
export { ForwardRef as ReactComponent };